import React from 'react'
import styled from '@emotion/styled'
import PageWidthContainer from 'components/bookingManagement/presentational/PageWidthContainer'
import {SeoBreadcrumb} from 'components/SeoSRP/SeoBreadcrumb'
import {useApSeoBreadcrumb} from 'hooks/useApSeoBreadcrumb'

import {Divider} from '@vio/atlas/src/components/designSystem/Divider'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const SeoBreadcrumbWrapper = styled(SeoBreadcrumb)`
  padding: ${cssTheme.layout.spacing.s700} ${cssTheme.layout.spacing.s500};

  ${linariaMq.desktopXs} {
    padding: ${cssTheme.layout.spacing.s900} 0;
  }
`

export const ApSeoBreadcrumb = () => {
  const breadcrumb = useApSeoBreadcrumb()
  const {isMobile} = useDeviceLayout()

  if (!breadcrumb.length) return null

  return (
    <PageWidthContainer>
      <Divider sideMargin={isMobile ? 's500' : 's000'} />
      <SeoBreadcrumbWrapper breadcrumb={breadcrumb} />
    </PageWidthContainer>
  )
}
